import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  Context,
  fetchPackages,
  notFoundPath,
  questionnaireStatisticsPath,
  classPath,
} from "../../../teacherStore";
import QuestionnaireList from "../../../templates/teacher/QuestionnaireList";
import { IStudent, IClass } from "../../../state";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const location = useLocation<{ student: IStudent; currentClass: IClass }>();

  if (!location.state) {
    history.push(notFoundPath);
    return null;
  }

  React.useEffect(() => {
    dispatch(fetchPackages(location.state.currentClass.id));
  }, [dispatch, location.state.currentClass.id]);

  const directTo = React.useCallback(
    (teaching_material_id: number) => {
      history.push(
        `${questionnaireStatisticsPath}/${teaching_material_id}/${location.state.student.id}`,
        location.state,
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history],
  );

  const goBack = React.useCallback(
    () => {
      history.push(`${classPath}/${location.state.student.class_id}`);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history],
  );

  return (
    <QuestionnaireList
      currentClass={location.state.currentClass}
      student={location.state.student}
      packageQuestion={state.packages}
      directTo={directTo}
      goBack={goBack}
    />
  );
};
